var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_998_427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8926 10.9408C15.0342 11.7158 15.8342 12.7658 15.8342 14.1658V16.6658H19.1676V14.1658C19.1676 12.3491 16.1926 11.2741 13.8926 10.9408Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5009 9.99919C14.3426 9.99919 15.8342 8.50752 15.8342 6.66585C15.8342 4.82419 14.3426 3.33252 12.5009 3.33252C12.1092 3.33252 11.7426 3.41585 11.3926 3.53252C12.0842 4.39085 12.5009 5.48252 12.5009 6.66585C12.5009 7.84919 12.0842 8.94085 11.3926 9.79919C11.7426 9.91585 12.1092 9.99919 12.5009 9.99919Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5013 9.99919C9.34297 9.99919 10.8346 8.50752 10.8346 6.66585C10.8346 4.82419 9.34297 3.33252 7.5013 3.33252C5.65964 3.33252 4.16797 4.82419 4.16797 6.66585C4.16797 8.50752 5.65964 9.99919 7.5013 9.99919ZM7.5013 4.99919C8.41797 4.99919 9.16797 5.74919 9.16797 6.66585C9.16797 7.58252 8.41797 8.33252 7.5013 8.33252C6.58464 8.33252 5.83464 7.58252 5.83464 6.66585C5.83464 5.74919 6.58464 4.99919 7.5013 4.99919Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50065 10.8328C5.27565 10.8328 0.833984 11.9494 0.833984 14.1661V16.6661H14.1673V14.1661C14.1673 11.9494 9.72565 10.8328 7.50065 10.8328ZM12.5007 14.9994H2.50065V14.1744C2.66732 13.5744 5.25065 12.4994 7.50065 12.4994C9.75065 12.4994 12.334 13.5744 12.5007 14.1661V14.9994Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_998_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsLogo);
export default __webpack_public_path__ + "static/media/groupsLogo.92def9f25cb4a99cbcfe9bd03964b692.svg";
export { ForwardRef as ReactComponent };